import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
  CanLoad,
  Route
} from "@angular/router";
import { Store, select } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { adminState } from "src/app/store/admin.reducers";
import * as adminProfileActions from "src/app/store/admin-actions";
import { SharedService } from "../services/shared.service";

@Injectable({
  providedIn: "root",
})
export class AdminModuleGuard implements CanLoad, CanActivate, CanActivateChild {
  adminDetail$: Observable<adminState>;
  storeSubscribe: Subscription;
  adminDetails: adminProfileActions.adminProfileDetails;

  constructor(
    private router: Router,
    private store: Store<{ adminDetails: adminState }>,
    private shared: SharedService
  ) {
    //this.adminDetail$ = store.pipe(select("adminDetails"));
  }

  canLoad(  route: Route  ):  Observable<boolean> | Promise<boolean> | boolean {
     return this.checkLogIn(route.path);

  }

  lazyLoad(  
    state: RouterStateSnapshot
  ): boolean{
    let url: string = state.url;

    return this.checkLogIn(url);
    
  }
  

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let url: string = state.url;

    return this.checkLogIn(url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.canActivate(route, state);
  }

  checkLogIn(url: string): boolean {
    console.log(url)
    let isLoggedIn = localStorage.getItem("isLoggedIn");
    this.adminDetails = JSON.parse(localStorage.getItem("user_details"));
    let role;
    if (isLoggedIn === "true") {
      role = this.adminDetails.memberships[0].role;

      console.log(role);

      if (
        (url === "/admin/activity" || url === "/admin/people") &&
        (role !== "admin"  &&
          role !== "evangelism"  &&
          role !== "fellowship"  &&
          role  !== "super_admin")
      ) {
        this.router.navigate(["onboarding/login"]);
       }

      if (
        (url === "/admin/people/regular-members" ||
          url === "/admin/people/new-convert" ||
          url === "/admin/people/first-timers") &&
        (role !== "admin"  &&  role  !== "super_admin")
      ) {
        this.router.navigate(["onboarding/login"]);
       }
      if (
        url === "/admin/people/evangelism" &&
        (role !== "admin"  &&
        role  !== "super_admin"  &&
          role !== "evangelism")
      ) {
        this.router.navigate(["onboarding/login"]);
       // return false;
      }
      if (
        url === "/admin/people/house-fellowship" &&
        (role !== "admin" &&
          role !== "fellowship" &&
          role  !== "super_admin")
      ) {
        
        this.router.navigate(["onboarding/login"]);
       }

      if (
        (url === "/admin/events" || url === "/admin/department") &&
        (role !== "admin"  &&  role  !== "super_admin")
      ) {
        this.router.navigate(["onboarding/login"]);
       }
      if (
        url === "/admin/reporting" &&
        (role !== "admin"  &&
        role  !== "super_admin"  &&
          role !== "financials"  &&
          role !== "reporting")
      ) {
        this.router.navigate(["onboarding/login"]);
        // return false;
      }
      if (
        (url.includes("/admin/financials")   ||
          url === "/admin/more") &&
        (role !== "admin"  &&
        role  !== "super_admin"  &&
          role !== "financials")
      ) {
        this.router.navigate(["onboarding/login"]);
       }

      if (
        (url === "/admin/more/media" ||
          url === "/admin/more/messages" ||
          url === "/admin/more/online-giving" ||
          url === "/admin/more/location" ||
          url === "/admin/more/groups") &&
        (role !== "admin"  &&  role  !== "super_admin")
      ) {
        this.router.navigate(["onboarding/login"]);
       }

      if (
        (url === "/admin/more/web-connect" ||
          url === "/admin/more/mobile-connect") &&
        (role !== "admin"  &&
        role  !== "super_admin" &&
          role !== "member_connect")
      ) {
        this.router.navigate(["onboarding/login"]);
       }

      if (
        (url === "/admin/settings/online-giving" ||
          url === "/admin/settings/thrash" ||
          url === "/admin/settings/billing-information") &&
        (role !== "admin"  &&  role  !== "super_admin")
      ) {
        this.router.navigate(["onboarding/login"]);
       }
      if (
        (url === "/admin/settings/web-connect" ||
          url === "/admin/settings/mobile-connect") &&
        (role !== "admin"  &&
        role  !== "super_admin"  &&
          role !== "member_connect")
      ) {
        this.router.navigate(["onboarding/login"]);
       } 
        return true;
      
    } else{
         this.router.navigate(["onboarding/login"]);
      

    }
 

  }

  checkRole(url: string): boolean {
    // let isAdmin: boolean;

    // this.adminDetails.memberships[0].role === "admin" ||
    // this.adminDetails.memberships[0].role.split("_").join(" ") === "super admin"
    //   ? (isAdmin = true)
    //   : (isAdmin = false);

    // console.log(isAdmin);
    return false;
  }
}
